import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchBackofficeInterviewLink, updateBackofficeInterviewLink } from './api';

export function useInterviewLink(projectId: string) {
  const queryClient = useQueryClient();
  const queryKey = ['backoffice-interview-link', projectId];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => fetchBackofficeInterviewLink(projectId, signal),
    staleTime: 30_000,
  });
  const update = useMutation({
    mutationFn: (hostname: string) => updateBackofficeInterviewLink(projectId, hostname),
    onSuccess: (link) => {
      queryClient.setQueryData(queryKey, link);
    },
  });
  return { ...query, update };
}
